import React, { useEffect, useState } from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { APIProvider, Map, AdvancedMarker } from '@vis.gl/react-google-maps';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import api from '../utils/api';

const Contact = () => {
  const [shopInfo, setShopInfo] = useState(null);
  const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

  useEffect(() => {
    fetchShopInfo();
  }, []);

  const fetchShopInfo = async () => {
    try {
      const response = await api.get('/info/shop');
      setShopInfo(response.data);
    } catch (error) {
      console.error('Error fetching shop info:', error);
    }
  };

  const defaultInfo = {
    name: 'Balaji Enterprises',
    address: 'Industrial Area, Sector 15, Mumbai, Maharashtra 400001',
    phone: '+91 9876543210',
    email: 'contact@balajienterprises.com',
    hours: 'Mon-Sat: 9:00 AM - 7:00 PM, Sun: Closed',
    location: { lat: 19.0760, lng: 72.8777 }
  };

  const info = shopInfo || defaultInfo;

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      <div className="flex-1 bg-slate-50 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading text-4xl lg:text-5xl font-bold text-primary mb-8 uppercase tracking-tight" data-testid="contact-heading">
            Contact Us
          </h1>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Contact Information */}
            <div className="space-y-6">
              <div className="bg-white rounded-sm shadow-sm p-6" data-testid="contact-info">
                <h2 className="font-heading text-2xl font-bold text-primary mb-6 uppercase">Get in Touch</h2>
                
                <div className="space-y-4">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-secondary/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <MapPin className="h-6 w-6 text-secondary" />
                    </div>
                    <div>
                      <h3 className="font-heading text-lg font-bold text-primary uppercase mb-1">Address</h3>
                      <p className="text-slate-600" data-testid="shop-address">{info.address}</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-secondary/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <Phone className="h-6 w-6 text-secondary" />
                    </div>
                    <div>
                      <h3 className="font-heading text-lg font-bold text-primary uppercase mb-1">Phone</h3>
                      <p className="text-slate-600" data-testid="shop-phone">{info.phone}</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-secondary/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <Mail className="h-6 w-6 text-secondary" />
                    </div>
                    <div>
                      <h3 className="font-heading text-lg font-bold text-primary uppercase mb-1">Email</h3>
                      <p className="text-slate-600" data-testid="shop-email">{info.email}</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-secondary/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <Clock className="h-6 w-6 text-secondary" />
                    </div>
                    <div>
                      <h3 className="font-heading text-lg font-bold text-primary uppercase mb-1">Business Hours</h3>
                      <p className="text-slate-600" data-testid="shop-hours">{info.hours}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-secondary/10 border-l-4 border-l-secondary rounded-sm p-6">
                <h3 className="font-heading text-xl font-bold text-primary mb-2 uppercase">Visit Our Store</h3>
                <p className="text-slate-700">
                  Come visit our showroom to see our extensive range of industrial hardware products. Our experts are ready to assist you with your project needs.
                </p>
              </div>
            </div>

            {/* Map */}
            <div className="bg-white rounded-sm shadow-sm overflow-hidden" data-testid="shop-map">
              <div className="h-full min-h-[500px]">
                {GOOGLE_MAPS_API_KEY ? (
                  <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
                    <Map
                      defaultCenter={info.location}
                      defaultZoom={15}
                      mapId="balaji-shop-map"
                      gestureHandling="greedy"
                      disableDefaultUI={false}
                      zoomControl={true}
                    >
                      <AdvancedMarker position={info.location}>
                        <div className="w-12 h-12 bg-secondary rounded-full flex items-center justify-center shadow-lg">
                          <MapPin className="h-7 w-7 text-white" />
                        </div>
                      </AdvancedMarker>
                    </Map>
                  </APIProvider>
                ) : (
                  <div className="w-full h-full bg-slate-100 flex items-center justify-center p-8">
                    <div className="text-center">
                      <MapPin className="h-16 w-16 text-slate-400 mx-auto mb-4" />
                      <h3 className="font-heading text-xl font-bold text-primary mb-2 uppercase">Our Location</h3>
                      <p className="text-slate-600">{info.address}</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Contact;